"use client";

import * as React from "react";

type Props = {
  entryId?: string;
  documentNo?: string;
};

export default function DocumentPreviewButton({ entryId, documentNo }: Props) {
  const [open, setOpen] = React.useState(false);

  const canOpen = !!entryId && !!documentNo && documentNo !== "-";
  if (!canOpen) {
    return <span style={{ color: "var(--muted)" }}>-</span>;
  }

  const src = `/api/documents/view?entryId=${encodeURIComponent(entryId as string)}`;

  return (
    <>
      <button type="button" className="btn btn-ghost" onClick={() => setOpen(true)}>
        Beleg ansehen
      </button>

      {open && (
        <div className="doc-modal-overlay" onClick={() => setOpen(false)}>
          <div className="doc-modal" onClick={(e) => e.stopPropagation()}>
            <div className="doc-modal-head">
              <div>
                <div className="doc-modal-title">Belegvorschau</div>
                <div className="doc-modal-sub">{documentNo}</div>
              </div>
              <button className="secondary-btn" type="button" onClick={() => setOpen(false)}>
                Schliessen
              </button>
            </div>
            <div className="doc-modal-body">
              <iframe
                src={src}
                title={`Beleg ${documentNo}`}
                className="doc-modal-frame"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
